import Color from '../Color.mjs'
import superMeta from '../_ARCH_CAT/metaArchCatNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.CYAN,
    childType: 'DB',
    detailUrl: '/ProjectDbMap',
    name: '库表模型',
    type: 'CAT_DB',
}
